import Button, { ButtonVariant } from '@/components/BaseLibrary/Button/Button';
import useStyles from '@/components/InteractiveQuoteForm/InteractiveQuoteForm.styles';
import { trackEvents } from '@/utils/analytics';
import { OwnHome } from '@/utils/validation/inputs';

interface ZipCodeStepProps {
  handleNext: (data: OwnHome) => void;
}

export default function ZipCodeStep({ handleNext }: ZipCodeStepProps) {
  const { classes } = useStyles();

  const onSubmit = (data: OwnHome) => {
    const ownsHome = data === OwnHome.OWN;

    trackEvents({
      event: 'Form_cta_click',
      Form_tab: 'Home Ownership',
      Form_step: 2,
      click_text: ownsHome ? 'Yes' : 'No',
    });
    handleNext(data);
  };

  return (
    <div className={classes.inputContainer}>
      <Button
        onClick={() => onSubmit(OwnHome.OWN)}
        label='Yes'
        className={classes.button}
      />
      <div className={classes.buttonContainer}>
        <Button
          onClick={() => onSubmit(OwnHome.RENT)}
          variant={ButtonVariant.SECONDARY}
          label='No'
          className={classes.button}
        />
      </div>
    </div>
  );
}
